import React, { useState, useContext, useEffect } from "react";
import * as S from "./PlusAnualStyle";
import Loading from "../Loader";
import { AuthContext } from "../../Context/AuthContext";
import { formatDate, formatNumber } from "../ASSETS/assets";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { contractAdminService } from "../../Services/contractAdminService";

export default function PlusAnual() {
  const { getPurchases, purchases, authState, logout } =
    useContext(AuthContext);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedContract, setSelectedContract] = useState(null);
  const [plusValue, setPlusValue] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (
      authState.permission &&
      authState.permission !== "ALL" &&
      !authState.permission.includes("PLUS ANUAL")
    ) {
      navigate("/");
    }
  }, [authState, navigate]);

  const fetchContract = async () => {
    if (!searchTerm) {
      alert("Por favor, digite um nome ou CPF para pesquisar.");
      return;
    }
    setLoading(true);
    try {
      await getPurchases(100, 0, "asc", "", searchTerm);
    } catch (e) {
      console.error("Erro ao buscar contratos:", e);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setSearchTerm("");
    setSelectedContract(null);
    setPlusValue("");
  };

  const handleSendPlus = async () => {
    if (!plusValue || parseFloat(plusValue) <= 0) {
      alert(
        "Por favor, insira um valor de porcentagem válido e maior que zero."
      );
      return;
    }
    setLoading(true);
    const payload = { percentageValue: parseFloat(plusValue) };
    try {
      await contractAdminService.addPlus(selectedContract.contract.id, payload);
      alert("PLUS adicionado com sucesso!");
      resetForm();
      getPurchases(100, 0, "asc", "", searchTerm);
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        alert("Sessão Expirada. Por favor, faça login novamente.");
        logout();
      } else {
        const errorMessage = error.response?.data?.message || error.message;
        alert(`Erro ao adicionar PLUS: ${errorMessage}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <S.PLUSContainer>
      <Loading load={loading} />
      <S.ContentBox>
        <S.Header>
          <h1>Adicionar Plus Anual</h1>
        </S.Header>
        <S.Step>
          <h4>1. Pesquise e selecione o contrato</h4>
          <S.ClientSearch>
            <div className="inputBoxFilter">
              <input
                type="text"
                placeholder="NOME OU CPF do cliente"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && fetchContract()}
              />
            </div>
          </S.ClientSearch>
          <S.ButtonSearch>
            <button onClick={fetchContract}>Procurar Contratos</button>
          </S.ButtonSearch>
        </S.Step>
        <S.SearchedClients>
          <div className="columns">
            <span>ID Cont.</span>
            <span>Cliente</span>
            <span>Valor Total</span>
            <span>Data Fim</span>
          </div>
          {selectedContract ? (
            <div className="rowSelected">
              <span>{selectedContract.contract.id}</span>
              <span>{selectedContract.clientName}</span>
              <span>
                R$ {formatNumber(selectedContract.contract.totalPrice)}
              </span>
              <span>
                {formatDate(selectedContract.contract.endContractDate)}
              </span>
              <button onClick={() => setSelectedContract(null)}>
                <FaTimes />
              </button>
            </div>
          ) : (
            <div className="tabelona">
              {purchases.map((purchase) => (
                <div
                  onClick={() => setSelectedContract(purchase)}
                  className="row"
                  key={purchase.contract.id}
                >
                  <span>{purchase.contract.id}</span>
                  <span>{purchase.clientName}</span>
                  <span>R$ {formatNumber(purchase.contract.totalPrice)}</span>
                  <span>{formatDate(purchase.contract.endContractDate)}</span>
                </div>
              ))}
            </div>
          )}
        </S.SearchedClients>
        {selectedContract && (
          <S.QuandoDeseja>
            <h4>2. Informe o valor do PLUS</h4>
            <div className="form-container">
              <div className="input-group">
                <label>Valor a adicionar (%)</label>
                <input
                  type="number"
                  placeholder="Ex: 5"
                  value={plusValue}
                  onChange={(e) => setPlusValue(e.target.value)}
                />
              </div>
              <button className="submit-button" onClick={handleSendPlus}>
                Adicionar PLUS
              </button>
            </div>
          </S.QuandoDeseja>
        )}
      </S.ContentBox>
    </S.PLUSContainer>
  );
}
